var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.step == 1
    ? _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { sm: "12" } },
                    [
                      _c("w-info", {
                        attrs: {
                          text: _vm.$ct("complete-peppol-settings-info"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "12" } },
                    [
                      _c("w-input", {
                        attrs: {
                          "has-error": _vm.hasError.name,
                          label: _vm.$ct("name"),
                          fancy: "",
                        },
                        on: {
                          keydown: function ($event) {
                            _vm.hasError.name = false
                          },
                        },
                        model: {
                          value: _vm.value.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "name", $$v)
                          },
                          expression: "value.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "12" } },
                    [
                      _c("w-input", {
                        attrs: {
                          "has-error": _vm.hasError.vatNumber,
                          label: _vm.$ct("vat-number"),
                          fancy: "",
                        },
                        on: {
                          keydown: function ($event) {
                            _vm.hasError.vatNumber = false
                          },
                          blur: function ($event) {
                            return _vm.onVatBlur()
                          },
                        },
                        model: {
                          value: _vm.value.vatNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "vatNumber", $$v)
                          },
                          expression: "value.vatNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "8", md: "10" } },
                    [
                      _c("w-input", {
                        attrs: {
                          "has-error": _vm.hasError.streetName,
                          label: _vm.$ct("street"),
                          fancy: "",
                        },
                        on: {
                          keydown: function ($event) {
                            _vm.hasError.streetName = false
                          },
                        },
                        model: {
                          value: _vm.value.streetName,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "streetName", $$v)
                          },
                          expression: "value.streetName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "4", md: "2" } },
                    [
                      _c("w-input", {
                        attrs: {
                          "has-error": _vm.hasError.streetNumber,
                          label: _vm.$ct("street-number"),
                          fancy: "",
                        },
                        on: {
                          keydown: function ($event) {
                            _vm.hasError.streetNumber = false
                          },
                        },
                        model: {
                          value: _vm.value.streetNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "streetNumber", $$v)
                          },
                          expression: "value.streetNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "8", md: "8" } },
                    [
                      _c("w-input", {
                        attrs: {
                          "has-error": _vm.hasError.cityName,
                          label: _vm.$ct("city"),
                          fancy: "",
                        },
                        on: {
                          keydown: function ($event) {
                            _vm.hasError.cityName = false
                          },
                        },
                        model: {
                          value: _vm.value.cityName,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "cityName", $$v)
                          },
                          expression: "value.cityName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "4", md: "4" } },
                    [
                      _c("w-input", {
                        attrs: {
                          "has-error": _vm.hasError.postalCode,
                          label: _vm.$ct("postal"),
                          fancy: "",
                        },
                        on: {
                          keydown: function ($event) {
                            _vm.hasError.postalCode = false
                          },
                        },
                        model: {
                          value: _vm.value.postalCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "postalCode", $$v)
                          },
                          expression: "value.postalCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "12" } },
                    [
                      _c("app-country-code-autocomplete", {
                        attrs: {
                          "has-error": _vm.hasError.countryCode,
                          label: _vm.$ct("country-code"),
                          fancy: "",
                        },
                        on: {
                          keydown: function ($event) {
                            _vm.hasError.countryCode = false
                          },
                        },
                        model: {
                          value: _vm.value.countryCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "countryCode", $$v)
                          },
                          expression: "value.countryCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-input", {
                        attrs: {
                          "has-error": _vm.hasError.phone,
                          label: _vm.$ct("phone"),
                          fancy: "",
                        },
                        on: {
                          keydown: function ($event) {
                            _vm.hasError.phone = false
                          },
                        },
                        model: {
                          value: _vm.value.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "phone", $$v)
                          },
                          expression: "value.phone",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-input", {
                        attrs: {
                          "has-error": _vm.hasError.email,
                          label: _vm.$ct("email"),
                          fancy: "",
                        },
                        on: {
                          keydown: function ($event) {
                            _vm.hasError.email = false
                          },
                        },
                        model: {
                          value: _vm.value.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "email", $$v)
                          },
                          expression: "value.email",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                { staticClass: "cancel", on: { click: _vm.cancel } },
                [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("common.next")) + " ")]
              ),
            ],
            1
          ),
          _c(
            "w-modal",
            { attrs: { value: _vm.autoFillData != null } },
            [
              _vm.autoFillData
                ? _c("app-dossier-edit-auto-fill-modal", {
                    attrs: { data: _vm.autoFillData },
                    on: {
                      close: function ($event) {
                        _vm.autoFillData = null
                      },
                      confirm: function ($event) {
                        return _vm.autoFill($event)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { sm: "12" } },
                    [
                      _c("w-info", {
                        attrs: {
                          text: _vm.$ct("complete-peppol-settings-iban"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    [
                      _c("w-input-autocomplete", {
                        attrs: {
                          label: _vm.$ct("peppol-iban"),
                          items: _vm.filteredBankTypes,
                          fancy: "",
                        },
                        on: {
                          "item-click": function ($event) {
                            return _vm.peppolIbanClicked($event)
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (p) {
                              return [
                                _vm._v(" " + _vm._s(p.item.Iban)),
                                _c("br"),
                                _vm._v(" " + _vm._s(p.item.Name) + " "),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.settings.UBL.PeppolIban,
                          callback: function ($$v) {
                            _vm.$set(_vm.settings.UBL, "PeppolIban", $$v)
                          },
                          expression: "settings.UBL.PeppolIban",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    [
                      _c("w-input", {
                        attrs: { label: _vm.$ct("peppol-bic"), fancy: "" },
                        model: {
                          value: _vm.settings.UBL.PeppolBic,
                          callback: function ($$v) {
                            _vm.$set(_vm.settings.UBL, "PeppolBic", $$v)
                          },
                          expression: "settings.UBL.PeppolBic",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                { staticClass: "cancel", on: { click: _vm.cancel } },
                [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.finish()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("common.save")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }